import { useLanguage } from "@/context/AppContext";

export default function Statement() {
  const { t } = useLanguage();
  return (
    <section className="statement" data-testid="statement-section">
      <div>
        <span className="kicker">01</span>
        <h2>
          {t.statement.l1}
          <br />
          <em>{t.statement.l2}</em>
        </h2>
      </div>
      <p>{t.statement.p}</p>
    </section>
  );
}
